import { NumericSeries } from "../series/numeric-series";

/** Placeholder vocabulary for derived plot channels. */
export type DerivedChannels = Readonly<{
  smoothed: Option<NumericSeries<number>>;
  confidence: Option<NumericSeries<number>>;
  density: Option<NumericSeries<number>>;
  trust: Option<NumericSeries<number>>;
  segments: Option<readonly NumericSeries<number>[]>;
  buckets: Option<NumericSeries<number>>;
}>;

export namespace DerivedChannels {
  export function empty(): DerivedChannels {
    return Object.freeze({
      smoothed: null,
      confidence: null,
      density: null,
      trust: null,
      segments: null,
      buckets: null,
    });
  }
}
